const testimonials = [
  {
    name: "Marcus J.",
    location: "West Palm Beach, FL",
    rating: 5,
    text: "I had a business trip to Mexico City in ten days and pulled my passport out of the safe for the first time in two years. Expired. I started the process with Fast Passport Center on Monday afternoon, shipped my documents overnight from the FedEx on Okeechobee Boulevard, and had my new passport by Thursday. Made my flight without a single issue. As a downtown professional, I do not have time to drive to Miami and wait in lines.",
    service: "Passport Renewal",
  },
  {
    name: "Sandra L.",
    location: "Lake Worth Beach, FL",
    rating: 5,
    text: "Our family of four was booked on a Caribbean cruise departing Port Everglades in nine days. I checked our passports the night before we were supposed to drive to the port and discovered my daughter's passport had expired three months earlier. I panicked. Fast Passport Center walked me through exactly what to do, I shipped everything the next morning, and her passport arrived the day before we left. We made the cruise. I cannot thank them enough.",
    service: "Child Passport",
  },
  {
    name: "Diana R.",
    location: "West Palm Beach, FL",
    rating: 5,
    text: "I am a Kravis Center patron and had tickets to the Paris Opera Ballet with a group of fellow arts supporters. Two weeks before departure I realized my passport expired two months prior. Fast Passport Center processed my renewal in four business days. Their team was professional, responsive, and understood the urgency of a non-refundable cultural trip. I have since recommended them to three friends in my arts circle.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WestPalmTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What West Palm Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from West Palm Beach, Lake Worth Beach, and Palm Beach County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}